// Utilitaires TVA partagés entre VatEditor, TransactionRow et ReceiptImportPage.

export const VAT_PRESETS = [
  { label: '0%',    value: 0 },
  { label: '5,5%',  value: 5.5 },
  { label: '10%',   value: 10 },
  { label: '20%',   value: 20 },
  { label: 'Autre', value: 'custom' },
  // Montant de TVA saisi librement en € — pour les tickets multi-taux où aucun
  // taux unique ne colle (ex. courses alimentaire 5,5 % + produits 20 %).
  { label: 'Montant', value: 'amount' },
];

// Taux courants proposés ligne par ligne en mode multi-taux.
export const MULTI_RATE_PRESETS = [20, 10, 5.5, 2.1, 0];

/** Calcule la TVA depuis TTC : montant_tva = TTC × taux / (100 + taux) */
export function computeVatFromTtc(amountCents, rate) {
  if (!amountCents || !rate) return 0;
  return Math.round((amountCents * rate) / (100 + rate));
}

/** Formate un taux à la française : 5.5 → "5,5", 20 → "20". */
export function formatRateFr(rate) {
  if (rate == null || Number.isNaN(rate)) return '?';
  return rate.toLocaleString('fr-FR', { maximumFractionDigits: 2 });
}
